import firebase from 'firebase/compat/app';
import { firebaseConfig } from './firebaseconfig';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import Swal from 'sweetalert';

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore();
const storage = firebase.storage();

// PEGAR O ANO ATUAL
const dataAtual = new Date();
const anoAtual = dataAtual.getFullYear();
localStorage.setItem('ano', anoAtual);
const ANO = localStorage.getItem('ano');


const lerProvas = (serie) => {
    return new Promise((resolve, reject) => {
        const provas = [];
        const unsubscribe = db.collection(ANO)
        .doc('provas')
        .collection(serie)
        .orderBy('date')
        .limit(10)
        .get()
        .then((querySnapshot) => {
            if (querySnapshot.empty) {
                resolve(provas);
            } else {
                querySnapshot.forEach((doc) => {
                    const id = doc.id;
                    const corFundo = doc.data().corFundo;
                    const corTexto = doc.data().corTexto;
                    const disciplina = doc.data().disciplina;
                    const data = doc.data().data;
                    provas.push({
                        corTexto: corTexto,
                        corFundo: corFundo,
                        disciplina: disciplina,
                        data: data,
                        serie: serie,
                        id: id,
                    });
                });
                resolve(provas);
            }
        })
        .catch((error) => {
            reject(error);
        });

    return () => unsubscribe();
    });
};

function formatarData(input) {
    try {
      const [dia, mes, ano] = input.split('/');
      const data = new Date(`${ano}-${mes}-${dia}`);
      const formatted = data.toLocaleDateString('pt-BR');
      return formatted;
    } catch (error) {
      return 'Formato de data inválido. Certifique-se de usar o formato dd/mm/aaaa.';
    }
  }
  

  const enviarProvas = (serie, disciplina, dataNormal, corFundo, corTexto) => {
    
    const enviar = new Promise( async (resolve, reject) => {
        
        const data = formatarData(dataNormal);
        
        if (serie && disciplina && data && corFundo && corTexto) {
         
            await db.collection(ANO)
            .doc('provas')
            .collection(serie)
            .add({
                corTexto: corTexto,
                corFundo: corFundo,
                disciplina: disciplina,
                data: data,
                serie: serie,
                date: firebase.firestore.FieldValue.serverTimestamp(),
            }).then((res) => {
                Swal({
                    title: `Prova de '${disciplina}' enviada para o ${serie} com Sucesso!`,
                    icon: 'success',
                    buttons: {
                    confirm: 'Ok',
                    },
                }).then((resposta) => {
                    window.location.reload();
                })
            });   
        } else {
            Swal({
                title: `Complete o formulário completamente!`,
                icon: 'error',
                buttons: {
                confirm: 'Ok',
                },
            })
        }

    });

    return enviar;
};

const excluirProva = (disciplina, serie, id) => {
    
    const excluir = new Promise( async (resolve, reject) => {
        
        Swal({
            title: `Você deseja excluir a prova de ${disciplina} do ${serie}?`,
            icon: 'warning',
            buttons: {
                confirm: 'Sim',
                cancel: 'Não',
            },
        }).then( async (response) => {
            if (response) {
                if (serie && id) {
                    await db.collection(ANO)
                    .doc('provas')
                    .collection(serie)
                    .doc(id).delete().then((res) => {
                        Swal({
                            title: `Prova excluída com Sucesso!`,
                            icon: 'success',
                            buttons: {
                            confirm: 'Ok',
                            },
                        }).then((resposta) => {
                            window.location.reload();
                        });
                    });   
                } else {
                    Swal({
                        title: `Oops, algo deu errado!`,
                        icon: 'error',
                        buttons: {
                        confirm: 'Ok',
                        },
                    });
                }
            }
        });
    });

    return excluir;
};



export { lerProvas, enviarProvas, excluirProva };